import { useTranslation } from 'react-i18next';
import { AUDIENCE_BADGE_CLASS } from '../../constants/audienceTypes';

const AudienceBadge = ({ audienceType = 'UNISEX', className = '' }) => {
  const { t } = useTranslation();
  const type = AUDIENCE_BADGE_CLASS[audienceType] ? audienceType : 'UNISEX';

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${AUDIENCE_BADGE_CLASS[type]} ${className}`}
    >
      {t(`salon.audience.${type}`)}
    </span>
  );
};

export default AudienceBadge;
